import React, { Component } from 'react';
import EmpreendimentoServiceCrawler from "../../services/empreendimentosServicesCrawler";

const labels = {
    "Venda": "Revenda",
    "Aluguel": "Locação"
}

class InfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {
            type,
            selectedArea,
            color,
            count_buildings,
            tipo_negocio,
            pdf,
            query_id,
            requestExcel,
            polos,
            setPolosGeradoresCurrentShowing,
            polos_cache_key
        } = this.props;

        return (
            <div className="info-card area-info ov-hidden">
                <hr className="info-card-hr hr-mapa" />

                {/* Cabeçalho padronizado com ícone colorido ao invés de borda */}
                <div className="info-card-header card-header">
                    <i className="fa-solid fa-circle" style={{ color: color || '#517E37' }}></i>
                    {" "}
                    {type.split(' ')[0]} {selectedArea.name}
                </div>

                <div className="card-body card-body-mapa-info">
                    {/* Bloco superior de informações */}
                    <div className='font19'>
                        <span className="">Tipo da Busca:</span> {type}
                    </div>

                    {(selectedArea.radius !== undefined) && (
                        <div className='font19'>
                            <span className="">Raio do Círculo:</span> {Number(selectedArea.radius).toFixed(2)}
                        </div>
                    )}

                    <hr className="info-card-hr hr-mapa" />

                    {/* Bloco inferior de dados principais */}
                    <div className='font19'>
                        <span className="info-card-label">Total de Imóveis:</span> {count_buildings.toLocaleString("pt-BR")}
                    </div>
                    <div className='font19 mb-3'>
                        <span className="info-card-label">Tipo de Negócio:</span> {labels[selectedArea.tipo_negocio]}
                    </div>

                    {/* Botões de Ação */}
                    <form action={pdf} method="GET">
                        <div className="info-card-btn-row">
                            {/* Botão Excel */}
                            {window.canExportRevendaLocacao && (
                                <button
                                    type="button"
                                    data-id={query_id}
                                    onClick={(event) => {
                                        event.preventDefault();
                                        requestExcel(query_id);
                                    }}
                                    className="info-card-btn info-card-btn-xls"
                                >
                                    EXCEL
                                </button>
                            )}

                            {/* Botão Polos */}
                            {window.authenticatedUserCanQueryPolos == true && polos && polos.length > 0 && (
                                <button
                                    type="button"
                                    className="info-card-btn info-card-btn-polos"
                                    onClick={() => {
                                        let agrupamentos = [];

                                        polos.map((polo) => {
                                            let found = agrupamentos.find((agrupamento) => {
                                                return agrupamento.category === polo.main_category || polo.categories[0] === agrupamento.category;
                                            });
                                            if (found) {
                                                found.count++;
                                            } else {
                                                let category = polo.main_category || polo.categories[0];
                                                agrupamentos.push({ category: category, count: 1 });
                                            }
                                        });

                                        setPolosGeradoresCurrentShowing(polos, agrupamentos, polos_cache_key);
                                    }}
                                >
                                    POLOS
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default InfoCard;